module.exports = __webpack_public_path__ + "static/img/swiper_04.96e67cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/prebook/swiper_04.png
// module id = X5uH
// module chunks = 1